export default {
  client: {
    type: "http",
    scheme: "bearer",
    in: "header"
  },
  user: {
    type: "http",
    scheme: "bearer",
    in: "header"
  }
};
